// Vendor imports
const _ = require('lodash')
const { createSelector } = require('reselect')
// Shared imports
const { TYPES: modelTypes } = require('shared/model-types')
// Client V2 common imports
const { FetchStateEnum } = require('client-v2/common/utils/enums')

const containerState = state => state.shareModal

const isVisible = createSelector(
  [
    state => state.user,
    containerState
  ],
  (user, s) => Boolean(
    _.get(s, 'feedItem') &&
    _.get(s, 'anchorId') == null &&
    !user.hasRollout('web_share_modal_v2')
  )
)

const submitState = createSelector(
  containerState,
  s => _.get(s, 'submitState')
)

const friends = createSelector(
  containerState,
  s => _.get(s, 'friends')
)

const friendsState = createSelector(
  containerState,
  s => _.get(s, 'friendsState')
)

const searchText = createSelector(
  containerState,
  s => _.get(s, 'searchText', '')
)

const friendsCount = createSelector(
  [
    friendsState,
    friends
  ],
  (friendsState, friends) => {
    if (friendsState === FetchStateEnum.LOADED) {
      return friends.size
    }
  }
)

const friendsSearch = createSelector(
  [
    friends,
    searchText
  ],
  (friends, searchText) => friends.filter(friend => (
    [ friend.username, friend['display_name'] ]
    .join(' ')
    .toLowerCase()
    .indexOf(searchText.toLowerCase()) > -1
  ))
)

const isSocialAuthCardVisible = createSelector(
  state => state.user.providers,
  providers => (
    !providers.has('facebook') ||
    !providers.has('twitter')
  )
)

const model = createSelector(
  containerState,
  s => {
    const feedItem = _.get(s, 'feedItem')
    return feedItem && feedItem.getModel()
  }
)

const isFriendsVisible = createSelector(
  [
    state => state.user.loggedIn,
    model
  ],
  (loggedIn, shareModalModel) => (
    loggedIn &&
    _.get(shareModalModel, 'type') === modelTypes.ARTICLE
  )
)

module.exports = {
  containerState,
  isVisible,
  submitState,
  searchText,
  friends,
  friendsCount,
  friendsState,
  friendsSearch,
  isFriendsVisible,
  isSocialAuthCardVisible,
  model
}
